export enum AllProductsProps {
  CREATE_PRODUCT = 'Create Product',
  DELETE_PRODUCT = 'Do you want to delete the product?',
  DELETE_SUBHEADING = 'By deleting the product, it will be permanently removed and you will not be able to retrieve it later.',
  COPY_PRODUCT = 'Do you want to duplicate the product?',
  COPY_SUBHEADING = 'By duplicating the product, it will be considered as a new product and you have submit the duplicated product for the verification to get the certificate',
  DELETE = 'delete',
  COPY = 'copy',
  DELETE_COMMODITY = 'Do you want to delete the commodity?',
  DELETE_COMMODITY_SUBHEADING = 'By deleting the commodity, it will be permanently removed and you will not be able to retrieve it later.',
}
